// @ts-nocheck — plain JS (not JSDoc-typed); exempt from the theme's strict checkJs.
/* ════════════════════════════════════════════════════════════
   CEREMONY PAGE — shared behaviour for all ceremony collection pages.
   - Customise buttons → scroll to form + pre-fill the chosen set
   - Form submit → structured Shopify /contact email + background Zoho lead
   - Per-card shipping estimate toggle (floating overlay)
   - AJAX add-to-cart with cart-bubble update + drawer open
   The lead source label (e.g. "Sahe Chithi") is read from the form's
   data-lead-source attribute so this file stays ceremony-agnostic.
   Markup: snippets/ceremony-*.liquid · Styles: assets/ceremony-page.css
   ════════════════════════════════════════════════════════════ */
(function () {
  // Guard against double-initialisation if the asset is ever included twice.
  if (window.__ceremonyPageInit) return;
  window.__ceremonyPageInit = true;

  document.addEventListener('DOMContentLoaded', function () {

    // ── Customise button: scroll to form + pre-fill product name ──
    var form        = document.getElementById('cp-customise-form');
    var badge       = document.getElementById('cp-selected-set-badge');
    var hiddenProd  = document.getElementById('cp-form-product');
    var formSection = document.getElementById('cp-customise');

    // Lead source for CRM routing — set per ceremony via data-lead-source.
    var leadSource = (form && form.dataset && form.dataset.leadSource) || 'Ceremony';

    // Set minimum event date to today
    var dateField = document.getElementById('cp-contact-event-date');
    if (dateField) {
      dateField.setAttribute('min', new Date().toISOString().split('T')[0]);
    }

    function scrollToForm(productName) {
      // Update badge and hidden field
      if (badge) badge.textContent = productName ? 'Enquiring about: ' + productName : '';
      if (hiddenProd) hiddenProd.value = productName || '';

      if (!formSection) return;

      // Safe header offset (no optional chaining)
      var headerEl = document.querySelector('.fixed_header_grp');
      var headerOffset = headerEl ? headerEl.offsetHeight : 80;
      var top = formSection.getBoundingClientRect().top + window.pageYOffset - headerOffset - 24;

      window.scrollTo({ top: top, behavior: 'smooth' });

      // Focus first input after scroll completes
      setTimeout(function () {
        var firstInput = formSection.querySelector('input:not([type=hidden])');
        if (firstInput) firstInput.focus();
      }, 700);
    }

    // Delegate click on all customise buttons
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cp-customise-btn');
      if (!btn) return;
      e.preventDefault();
      scrollToForm(btn.getAttribute('data-product') || '');
    });

    // ── Zoho CRM — background submission ──────────────────────────────────
    var ZOHO_ENDPOINT = 'https://forms.zohopublic.in/pataareestudiospvtltd/form/Bookaconsultation/formperma/r6bqRhf3TfRJazUrC6fOLq2SabzOvsUSy2IXrnbg14w/htmlRecords/submit';

    function formatDateForZoho(dateStr) {
      // Convert YYYY-MM-DD (HTML date input) → dd-MMM-yyyy (Zoho format)
      if (!dateStr) return '';
      var parts = dateStr.split('-');
      if (parts.length !== 3) return dateStr;
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var year  = parts[0];
      var month = months[parseInt(parts[1], 10) - 1] || parts[1];
      var day   = parts[2];
      return day + '-' + month + '-' + year;
    }

    function submitToZoho(fields) {
      // Build URLSearchParams — Zoho accepts application/x-www-form-urlencoded
      var params = new URLSearchParams();
      params.append('zf_referrer_name', '');
      params.append('zf_redirect_url',  '');
      params.append('zc_gad',           '');

      // Name — split on first space into First / Last
      var nameParts = (fields.name || '').trim().split(/\s+/);
      params.append('Name_First', nameParts[0] || '');
      params.append('Name_Last',  nameParts.slice(1).join(' ') || '');

      params.append('Email',                   fields.email               || '');
      params.append('PhoneNumber_countrycode', fields.phone               || '');
      params.append('SingleLine',              fields.city                || '');
      params.append('Date',                    formatDateForZoho(fields.eventDate));

      // MultiLine — all context in one block for the team
      var notes = [];
      if (fields.ceremony)  notes.push('Ceremony: ' + fields.ceremony);
      if (fields.product)   notes.push('Set enquired: ' + fields.product);
      if (fields.message)   notes.push(fields.message);
      params.append('MultiLine', notes.join('\n\n'));

      // Fire and forget — success/failure doesn't block the UI
      fetch(ZOHO_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString()
      }).catch(function (err) {
        // Silent fail — Shopify email is the guaranteed backup
        console.warn('[Pataaree] Zoho submission failed:', err.message);
      });
    }

    // ── Form submit: build structured body → Shopify + Zoho ───────────────
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        // Collect all field values once
        var name      = (form.querySelector('#cp-contact-name')       || {}).value || '';
        var email     = (form.querySelector('[name="contact[email]"]') || {}).value || '';
        var phone     = (form.querySelector('#cp-contact-phone')      || {}).value || '';
        var eventDate = (form.querySelector('#cp-contact-event-date') || {}).value || '';
        var city      = (form.querySelector('#cp-contact-city')       || {}).value || '';
        var message   = (form.querySelector('#cp-contact-message')    || {}).value || '';
        var product   = (hiddenProd || {}).value || '';

        // Build structured contact[body] for Shopify email — all data in one field
        var bodyField = document.getElementById('cp-form-body');
        if (bodyField) {
          bodyField.value = [
            '=== CUSTOMISATION LEAD — ' + leadSource + ' ===',
            product   ? 'Set of Interest: '    + product   : '',
            phone     ? 'WhatsApp / Phone: '   + phone     : '',
            eventDate ? 'Event Date: '         + eventDate : '',
            city      ? 'Location: '           + city      : '',
            message   ? '\nNotes:\n'           + message   : ''
          ].filter(Boolean).join('\n');
        }

        var submitBtn = form.querySelector('.cp-form__submit');
        var origText  = submitBtn.textContent;
        submitBtn.textContent = 'Sending...';
        submitBtn.disabled = true;

        // Fire Zoho submission in the background (doesn't block or affect UI)
        submitToZoho({ name: name, email: email, phone: phone,
                       eventDate: eventDate, city: city,
                       message: message, product: product, ceremony: leadSource });

        // Submit to Shopify /contact (guaranteed email backup)
        fetch('/contact#contact_form', { method: 'POST', body: new FormData(form) })
          .then(function (response) {
            if (response.ok) {
              window.location.href = '/pages/ceremony-thank-you';
            } else {
              form.submit(); // Non-200: fall back to native (return_to handles the redirect)
            }
          })
          .catch(function () {
            form.submit(); // Network error: submit natively, never lose data
          })
          .finally(function () {
            submitBtn.textContent = origText;
            submitBtn.disabled = false;
          });
      });
    }

    // ── Shipping rates toggle (floating overlay) ──
    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('.cp-shipping-toggle__btn');

      // Close any open panels when clicking outside
      if (!e.target.closest('.cp-shipping-toggle')) {
        document.querySelectorAll('.cp-shipping-rates').forEach(function (p) {
          p.setAttribute('hidden', '');
        });
        document.querySelectorAll('.cp-shipping-toggle__btn').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
      }

      if (!toggleBtn) return;

      var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      var thisPanel = toggleBtn.closest('.cp-shipping-toggle').querySelector('.cp-shipping-rates');

      // Close all other open panels first
      document.querySelectorAll('.cp-shipping-rates').forEach(function (p) {
        if (p !== thisPanel) {
          p.setAttribute('hidden', '');
        }
      });
      document.querySelectorAll('.cp-shipping-toggle__btn').forEach(function (b) {
        if (b !== toggleBtn) b.setAttribute('aria-expanded', 'false');
      });

      // Toggle this panel
      toggleBtn.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        thisPanel.setAttribute('hidden', '');
      } else {
        thisPanel.removeAttribute('hidden');
      }
    });

    // Smooth scroll for hero CTA anchors
    document.querySelectorAll('a[href^="#cp-"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        var headerEl2 = document.querySelector('.fixed_header_grp');
        var headerOffset2 = headerEl2 ? headerEl2.offsetHeight : 80;
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset2 - 16;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    // ATC handler — add the item, then let the store's cart drawer (UpCart)
    // open and refresh itself. UpCart auto-detects the /cart/add.js request.
    // We deliberately do NOT re-fetch the cart or open the theme's own cart
    // drawer here: doing both previously made a second cart appear and made
    // adding feel slow.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cp-atc-btn');
      if (!btn || btn.disabled) return;

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.classList.add('cp-atc-btn--loading');
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add-to-cart failed');
        return r.json();
      })
      .then(function () {
        btn.classList.remove('cp-atc-btn--loading');
        btn.classList.add('cp-atc-btn--added');
        btn.textContent = 'Added ✓';

        setTimeout(function () {
          btn.classList.remove('cp-atc-btn--added');
          btn.textContent = 'Add to Cart';
        }, 2500);
      })
      .catch(function (err) {
        console.error('ATC error:', err);
        btn.classList.remove('cp-atc-btn--loading');
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = 'Add to Cart'; }, 2000);
      });
    });

    // ── Pieces filter tabs (opt-in: only pages rendering pieces_filterable have this markup) ──
    var piecesFilterBar = document.querySelector('.cp-pieces-filter-bar');
    if (piecesFilterBar) {
      piecesFilterBar.addEventListener('click', function (e) {
        var tab = e.target.closest('.cp-pieces-ftab');
        if (!tab) return;
        piecesFilterBar.querySelectorAll('.cp-pieces-ftab').forEach(function (t) {
          t.classList.remove('cp-pieces-ftab--active');
        });
        tab.classList.add('cp-pieces-ftab--active');

        var filter = tab.dataset.cpFilter;
        document.querySelectorAll('.cp-individuals__grid [data-cp-piece-type]').forEach(function (card) {
          var show = filter === 'all' || card.dataset.cpPieceType === filter;
          card.classList.toggle('cp-piece-hidden', !show);
        });
      });
    }

    // ── Hero slider (opt-in: only pages rendering ceremony-hero-slider.liquid have this markup) ──
    var heroSlider = document.querySelector('.cp-hero-slider');
    if (heroSlider) {
      var hsSlides = heroSlider.querySelectorAll('.cp-hs-slide');
      var hsDots   = heroSlider.querySelectorAll('.cp-hs-dot');
      var hsCur    = 0;
      var hsTimer;

      function hsGoTo(n) {
        hsSlides[hsCur].classList.remove('cp-hs-slide--active');
        if (hsDots[hsCur]) hsDots[hsCur].classList.remove('cp-hs-dot--active');
        hsCur = (n + hsSlides.length) % hsSlides.length;
        hsSlides[hsCur].classList.add('cp-hs-slide--active');
        if (hsDots[hsCur]) hsDots[hsCur].classList.add('cp-hs-dot--active');
      }

      function hsRestartAutoplay() {
        clearInterval(hsTimer);
        hsTimer = setInterval(function () { hsGoTo(hsCur + 1); }, 6000);
      }

      heroSlider.addEventListener('click', function (e) {
        if (e.target.closest('[data-cp-hs-next]')) { hsGoTo(hsCur + 1); hsRestartAutoplay(); }
        if (e.target.closest('[data-cp-hs-prev]')) { hsGoTo(hsCur - 1); hsRestartAutoplay(); }
        var dot = e.target.closest('[data-cp-hs-goto]');
        if (dot) { hsGoTo(parseInt(dot.dataset.cpHsGoto, 10)); hsRestartAutoplay(); }
      });

      heroSlider.addEventListener('mouseenter', function () { clearInterval(hsTimer); });
      heroSlider.addEventListener('mouseleave', hsRestartAutoplay);

      hsRestartAutoplay();
    }

    // ── FAQ accordion (opt-in: only pages with faq_item blocks render .cp-faq) ──
    var faqItems = document.querySelectorAll('.cp-faq .faq-item');
    faqItems.forEach(function (item) {
      var q = item.querySelector('.faq-q');
      if (!q) return;
      q.addEventListener('click', function () {
        var willOpen = !item.classList.contains('open');
        item.classList.toggle('open', willOpen);
        q.setAttribute('aria-expanded', willOpen);
      });
    });

  }); // end DOMContentLoaded
})();
